import getSymbolFromCurrency from 'currency-symbol-map';

export const currencySymbol = (code: string | null | undefined): string => {
    if (!code) return '';
    const sym = getSymbolFromCurrency(code);
    return sym || code;
};

/** "₪ 42,850.00" / "$ 12,500" — symbol + space + grouped number. */
export function formatMoney(
    amount: number,
    currency: string | null | undefined,
    opts: { decimals?: number | 'auto' } = {}
): string {
    const decimalsOpt = opts.decimals ?? 2;
    const decimals = decimalsOpt === 'auto' ? (Number.isInteger(amount) ? 0 : 2) : decimalsOpt;
    const num = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(amount);
    return `${currencySymbol(currency)} ${num}`.trim();
}

export function formatDate(s: string | Date | null | undefined): string {
    if (!s) return '-';
    const d = s instanceof Date ? s : new Date(s);
    if (Number.isNaN(d.getTime())) return '-';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
}
